var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-doc-progress-toast-component" }, [
    _c(
      "div",
      { staticClass: "room-status-msg-views" },
      [
        _vm._l(_vm.uploadRoomDocFiles, function (uploadRoomDoc) {
          return [
            uploadRoomDoc.id && uploadRoomDoc.percent <= 100
              ? _c(
                  "div",
                  { key: uploadRoomDoc.id, staticClass: "room-status-msg" },
                  [
                    _c("div", { staticClass: "room-status-msg-wrapper" }, [
                      _c("div", { staticClass: "room-status-body" }, [
                        _c(
                          "div",
                          { staticClass: "room-status-msg-text-wrapper" },
                          [
                            _c("div", { staticClass: "room-status-msg-text" }, [
                              _vm._v(_vm._s(uploadRoomDoc.filename)),
                            ]),
                            _c("div", { staticClass: "room-status-progress" }, [
                              _c(
                                "div",
                                { staticClass: "room-status-progress-text" },
                                [_vm._v(_vm._s(uploadRoomDoc.percent) + "%")]
                              ),
                              _c("div", {
                                staticClass: "room-status-progressBg",
                              }),
                              _c("div", {
                                staticClass: "room-status-progress-bar",
                                style: { width: `${uploadRoomDoc.percent}%` },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        }),
        _vm._l(_vm.roomDoc.roomDocFiles, function (roomDocFile) {
          return [
            roomDocFile.docFile &&
            (roomDocFile.docFile.docState === 0 ||
              roomDocFile.docFile.docState === 1)
              ? _c(
                  "div",
                  { key: roomDocFile.docId, staticClass: "room-status-msg" },
                  [
                    _c("div", { staticClass: "room-status-msg-wrapper" }, [
                      _c("div", { staticClass: "room-status-body" }, [
                        _c(
                          "div",
                          { staticClass: "room-status-msg-text-wrapper" },
                          [
                            _c("div", { staticClass: "room-status-msg-text" }, [
                              _vm._v(_vm._s(roomDocFile.docName)),
                            ]),
                            _c("div", { staticClass: "room-status-progress" }, [
                              roomDocFile.docFile.docState === 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "room-status-progress-text",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          roomDocFile.docFile.docConvPageCnt
                                        ) +
                                          "/" +
                                          _vm._s(
                                            roomDocFile.docFile.docPageCnt > 0
                                              ? roomDocFile.docFile.docPageCnt
                                              : "..."
                                          )
                                      ),
                                    ]
                                  )
                                : roomDocFile.docFile.docState === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "room-status-progress-text",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("doc.list.transform.ready")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", {
                                staticClass: "room-status-progressBg",
                              }),
                              roomDocFile.docFile.docPageCnt > 0
                                ? _c("div", {
                                    staticClass: "room-status-progress-bar",
                                    style: {
                                      width: `${
                                        (roomDocFile.docFile.docConvPageCnt /
                                          roomDocFile.docFile.docPageCnt) *
                                        100
                                      }%`,
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }